import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Search } from "lucide-react";
import { loadMetiers, matchMetier, metierIcon } from "@/components/metiers/metierUtils";

/** Phase 89 — Landing : « Un module métier pour chaque activité » (30 cartes PBM-METIER-…, recherche, lien d'inscription pré-rempli). */
export const MetiersSection = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { loadMetiers().then(setItems).catch(() => setItems([])); }, []);
  const shown = useMemo(() => items.filter((m) => matchMetier(m, q)), [items, q]);
  if (!items.length) return null;
  return (
    <section className="border-b border-[#DEE2E6] bg-white" id="metiers" data-testid="landing-metiers">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid lg:grid-cols-3 gap-8 items-end mb-10">
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-[#002FA7] font-semibold mb-3">Modules métier</div>
            <h2 className="font-display text-3xl lg:text-5xl font-black tracking-tight" data-testid="landing-metiers-title">Un module métier pour chaque activité.</h2>
            <p className="mt-4 text-base text-[#495057] max-w-2xl">Choisissez votre métier à l'inscription : PAG active les écrans qui comptent pour vous (HACCP, rondes, chantiers, réservations, rendez-vous…) et vous propose un module de départ prêt à l'emploi. Inclus dans l'abonnement.</p>
          </div>
          <div className="relative">
            <Search className="h-4 w-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#868E96]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Votre activité : restaurant, garage, coiffure…" className="w-full h-12 pl-11 pr-4 border border-[#0A0A0A] text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" data-testid="landing-metiers-search" />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-[#0A0A0A] border border-[#0A0A0A]" data-testid="landing-metiers-grid">
          {shown.map((m) => {
            const Icon = metierIcon(m.icon);
            return (
              <Link key={m.code} to={`/inscription?metier=${m.code}`} className="group bg-white p-5 flex flex-col min-h-[150px] hover:bg-[#0A0A0A] hover:text-white transition-colors" data-testid={`landing-metier-${m.code}`} title={m.audience}>
                <div className="flex items-center justify-between"><Icon className="h-6 w-6 text-[#002FA7] group-hover:text-[#FFD700] transition-colors" /><ArrowUpRight className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" /></div>
                <div className="font-display font-bold text-sm leading-tight mt-4">{m.label}</div>
                <div className="text-[11px] opacity-60 mt-1 line-clamp-2">{m.audience}</div>
                <div className="mt-auto pt-3 font-mono text-[9px] opacity-40 tracking-wider">{m.code}</div>
              </Link>
            );
          })}
          {!shown.length && <div className="col-span-full bg-white p-8 text-center text-sm text-[#868E96]" data-testid="landing-metiers-empty">Aucun métier ne correspond à « {q} » — choisissez « Services aux entreprises » ou contactez-nous.</div>}
        </div>
        <div className="mt-6 text-xs text-[#868E96]" data-testid="landing-metiers-count">{items.length} modules métier · plusieurs métiers possibles par entreprise (ex. hôtel + restaurant).</div>
      </div>
    </section>
  );
};
